class QuickViewDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    this.addEventListener('close', () => {
      const drawerContent = this.querySelector('.quick-view__content');

      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');

      document.dispatchEvent(new CustomEvent('quickview:close'));
    });
  }
}

customElements.define('quick-view-drawer', QuickViewDrawer);


class QuickViewButton extends MenuDrawer {
  constructor() {
    super();

    this.addEventListener('click', () => {
      const wrapper = this.closest('.card-wrapper');
      const drawer = wrapper.querySelector('quick-view-drawer');

      if (drawer) {
        drawer.querySelector('summary').click();

        document.dispatchEvent(
          new CustomEvent('quickview:open', {
            detail: {
              productUrl: this.dataset.productUrl
            }
          })
        );
      } else if (this.dataset.productUrl) {
        window.location.href = this.dataset.productUrl;
      }
    });
  }
}

customElements.define('quick-view-button', QuickViewButton);


class QuickView extends HTMLElement {
  constructor() {
    super();

    this.isLoading = false;
  }

  connectedCallback() {
    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this)
    );

    this.observer.observe(this);
  }

  handleIntersection(entries) {
    if (!entries[0].isIntersecting) return;
    if (this.isLoading) return;

    const selector = '.quick-view__content';
    const drawerContent = this.querySelector(selector);

    if (!drawerContent) return;

    const productUrl = this.dataset.productUrl.split('?')[0];
    const sectionUrl = `${productUrl}?view=modal`;

    this.isLoading = true;

    fetch(sectionUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Quick View request failed: ${response.status}`);
        }

        return response.text();
      })
      .then(responseText => {
        const responseHTML = new DOMParser().parseFromString(
          responseText,
          'text/html'
        );

        const productElement = responseHTML.querySelector(selector);

        if (!productElement) {
          throw new Error('Quick View content was not found.');
        }

        /*
         * INDSÆT INDHOLDET MED DET SAMME
         * Ingen 200ms delay.
         */
        this.setInnerHTML(
          drawerContent,
          productElement.innerHTML
        );

        /*
         * Fjern cover/loading-state med det samme.
         * Ingen 500ms delay.
         */
        drawerContent.classList.add('hide-cover');

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        /*
         * Quick View er nu klar med det samme.
         */
        document.dispatchEvent(
          new CustomEvent('quickview:loaded', {
            detail: {
              productUrl: this.dataset.productUrl
            }
          })
        );
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    /*
     * Reinject script tags, så scripts fra modal-indholdet
     * stadig bliver eksekveret.
     */
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');

      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(
          attribute.name,
          attribute.value
        );
      });

      newScriptTag.appendChild(
        document.createTextNode(oldScriptTag.innerHTML)
      );

      oldScriptTag.parentNode.replaceChild(
        newScriptTag,
        oldScriptTag
      );
    });
  }
}

customElements.define('quick-view', QuickView);